type Breakpoints<T> = { xs: T; m?: T };

export type Video = {
  alt: string;
  aspectRatio?: string;
  autoPlay?: boolean;
  caption?: string;
  loop?: boolean;
  muted?: boolean;
  nativeControls?: boolean;
  poster?: string;
  src?: string;
  audioDescription?: string;
};

interface VideoConfigProps {
  alt: string;
  altPortrait: string;
  audioDescription?: string;
  audioDescriptionPortrait?: string;
  autoPlay: boolean;
  caption?: string;
  captionPortrait?: string;
  loop: boolean;
  muted: boolean;
  videoUrlLargeScreen: string;
  videoUrlSmallScreen: string;
  videoUrlLargeScreenPoster?: string;
  videoUrlSmallScreenPoster?: string;
  isMobile: boolean;
}

export type VideoPlayerConfig = {
  videos: Partial<Breakpoints<Video>>;
  playsInline: boolean;
  cover?: boolean;
  isFormatable?: boolean;
};

export function getVideoPlayerConfig(props: VideoConfigProps): VideoPlayerConfig {
  const {
    alt,
    altPortrait,
    audioDescription,
    audioDescriptionPortrait,
    autoPlay,
    caption,
    captionPortrait,
    loop,
    muted,
    videoUrlLargeScreen,
    videoUrlSmallScreen,
    isMobile,
    videoUrlLargeScreenPoster,
    videoUrlSmallScreenPoster,
  } = props;

  const parseContentToScreenSize = (): Video => {
    if (isMobile) {
      return {
        alt: altPortrait,
        aspectRatio: '1/1',
        audioDescription: audioDescriptionPortrait,
        autoPlay,
        caption: captionPortrait,
        loop,
        muted,
        nativeControls: true,
        src: videoUrlSmallScreen,
        poster: videoUrlSmallScreenPoster,
      };
    }

    return {
      alt,
      aspectRatio: '16/9',
      audioDescription,
      autoPlay,
      caption,
      loop,
      muted,
      nativeControls: true,
      src: videoUrlLargeScreen,
      poster: videoUrlLargeScreenPoster,
    };
  };

  return {
    cover: true,
    playsInline: true,
    videos: {
      xs: parseContentToScreenSize(),
    },
  };
}
